module.exports = __webpack_public_path__ + "static/img/loading.1674b2c7.svg";